import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"
import { Dialog, Table, Column, Button, Icon, Collapse } from "@tencent/spaui"
import ContactListView from "./ContactListView"
import SupplementaryPanel from "./SupplementaryPanel"
import WithPermission from "@/common/permissions/WithPermission.js"
import perms from "@/common/permissions/sale/perms"
import _ from "lodash"
import { getQuery } from "@/utils"
class ContactPanel extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    lead: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    secure: PropTypes.bool,
  }

  state = { collapse: false, additionalContactList: [] }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.lead, this.props.lead)) {
      this.getAdditionalContactList(nextProps.lead)
    }
  }
  componentDidMount() {
    this.getContactList()
    this.getAdditionalContactList(this.props.lead)
  }

  getContactList = () => {
    const {
      webApi,
      lead: { leadId },
    } = this.props
    const agencyId = getQuery("agencyId")
    webApi
      .getContactList(leadId, agencyId)
      .ajax()
      .then((resp) => {
        if (!resp) {
          return;
        }
        this.setState({
          contactList: resp,
        });
      });
  }

  getAdditionalContactList(lead) {
    const { webApi } = this.props
    const { leadId, additionalLeads } = lead
    if (!_.isEmpty(additionalLeads)) {
      webApi
        .getAdditionalContactList(leadId)
        .ajax()
        .then((resp) => {
          this.setState({
            additionalContactList: resp,
          })
        })
    }
  }

  updateDetail = () => {
    this.props.getDetail && this.props.getDetail()
    this.getContactList()
  }

  render() {
    const { contactList, collapse, additionalContactList } = this.state
    const {
      lead: { leadId, additionalLeads = [] },
      readOnly,
      secure,
      isLead,
      editPerm,
    } = this.props
    return (
      <div className="ContactPanel">
        <h2>联系人</h2>
        <div className="action-bar">
          <WithPermission reject={readOnly} oneOf={[perms.LEAD_EDIT_SELF, perms.LEAD_EDIT_GROUP, perms.LEAD_EDIT_ALL, perms.POTENTIAL_EDIT_SELF, perms.POTENTIAL_EDIT_GROUP, perms.POTENTIAL_EDIT_ALL]}>
            <Button size={"small"} onClick={this.handleAddContact}>
              添加联系人
            </Button>
          </WithPermission>
        </div>
        <ContactListView lead={this.props.lead} getContactList={this.updateDetail} isLead={isLead} leadId={leadId} contactList={contactList} readOnly={readOnly} secure={secure} editPerm={editPerm} />
        {!_.isEmpty(additionalLeads) && (
          <div>
            <div style={{ padding: "10px", fontSize: "12px", color: "#e88e00", cursor: "pointer" }} onClick={this.handleOpen}>
              <Icon name={`arrow-${collapse ? "up" : "down"}`} />
              点击{collapse ? "收起" : "展开"}增补信息
            </div>
            <Collapse open={collapse}>
              <div>
                {_.map(additionalLeads, (item, key) => {
                  let list = _.filter(additionalContactList, (val) => val.leadId === item.leadId)
                  return <SupplementaryPanel lead={item} key={key} dataKey={key} contactList={list} />
                })}
              </div>
            </Collapse>
          </div>
        )}
      </div>
    )
  }
  handleOpen = () => {
    const { collapse } = this.state
    this.setState({ collapse: !collapse })
  }
  handleAddContact = () => {}
}

export default withApi(ContactPanel)
